import React from "react";
import Button from "@amzn/meridian/button";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import { useBulkEditContext } from "../../store/bulk-edit-store";

export default function BulkEditPagination() {
  const { rows, currentPage, setCurrentPage, pageSize } = useBulkEditContext();

  const totalPages = Math.ceil(rows.length / pageSize);

  if (totalPages <= 1) {
    return null;
  }

  const goToPage = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <Row alignmentHorizontal="center" spacingInset="300 none">
      <Button
        type="tertiary"
        size="small"
        onClick={() => goToPage(currentPage - 1)}
        disabled={currentPage === 1}
      >
        ◀
      </Button>
      {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
        <Button
          key={page}
          type={page === currentPage ? "primary" : "tertiary"}
          size="small"
          onClick={() => goToPage(page)}
        >
          {page}
        </Button>
      ))}
      <Button
        type="tertiary"
        size="small"
        onClick={() => goToPage(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        ▶
      </Button>
      <Text type="b200">
        Page {currentPage} of {totalPages}
      </Text>
    </Row>
  );
}
